var map = {
	"./fonts/Circe-Bold.eot": 9186,
	"./fonts/Circe-Bold.ttf": 1412,
	"./fonts/Circe-Bold.woff": 9494,
	"./fonts/Circe-ExtraBold.eot": 8373,
	"./fonts/Circe-ExtraBold.ttf": 5297,
	"./fonts/Circe-ExtraBold.woff": 2591,
	"./fonts/Circe-ExtraLight.eot": 8905,
	"./fonts/Circe-ExtraLight.ttf": 420,
	"./fonts/Circe-ExtraLight.woff": 1173,
	"./fonts/Circe-Light.eot": 3501,
	"./fonts/Circe-Light.ttf": 5606,
	"./fonts/Circe-Light.woff": 9545,
	"./fonts/Circe-Regular.eot": 5342,
	"./fonts/Circe-Regular.ttf": 3154,
	"./fonts/Circe-Regular.woff": 3481,
	"./fonts/Circe-Thin.eot": 7560,
	"./fonts/Circe-Thin.ttf": 536,
	"./fonts/Circe-Thin.woff": 512,
	"./i/al-a-logo.png": 4945,
	"./i/image.svg": 2154,
	"./i/photo.svg": 5490,
	"./i/video.svg": 3618,
	"./images/advantage-1.jpg": 7542,
	"./images/advantage-2.jpg": 8731,
	"./images/advantage-3.jpg": 2291,
	"./images/cart.svg": 1082,
	"./images/category-catalog-1.png": 3457,
	"./images/category-catalog-2.png": 9065,
	"./images/category-catalog-3.png": 7380,
	"./images/category-catalog-4.png": 5539,
	"./images/category-catalog-5.png": 4350,
	"./images/category-catalog-6.png": 3019,
	"./images/category-catalog-7.png": 9365,
	"./images/category-catalog-8.png": 4841,
	"./images/check-square.svg": 5488,
	"./images/check.svg": 7845,
	"./images/favicon/android-chrome-192x192.png": 5333,
	"./images/favicon/android-chrome-512x512.png": 6707,
	"./images/favicon/apple-touch-icon-114x114.png": 9638,
	"./images/favicon/apple-touch-icon-120x120.png": 5077,
	"./images/favicon/apple-touch-icon-144x144.png": 5941,
	"./images/favicon/apple-touch-icon-152x152.png": 3153,
	"./images/favicon/apple-touch-icon-180x180.png": 407,
	"./images/favicon/apple-touch-icon-57x57.png": 4538,
	"./images/favicon/apple-touch-icon-60x60.png": 3665,
	"./images/favicon/apple-touch-icon-72x72.png": 1636,
	"./images/favicon/apple-touch-icon-76x76.png": 5922,
	"./images/favicon/apple-touch-icon.png": 1642,
	"./images/favicon/favicon-16x16.png": 6255,
	"./images/favicon/favicon-194x194.png": 2223,
	"./images/favicon/favicon-32x32.png": 8394,
	"./images/favicon/favicon.ico": 3525,
	"./images/favicon/mstile-150x150.png": 299,
	"./images/favicon/safari-pinned-tab.svg": 6069,
	"./images/favicon/site.webmanifest": 2002,
	"./images/left-arrow.svg": 917,
	"./images/login.svg": 3077,
	"./images/logo-gray.svg": 7537,
	"./images/logo.svg": 6776,
	"./images/logo_og.png": 1524,
	"./images/logo_white.svg": 4045,
	"./images/news-tile-1.jpg": 81,
	"./images/news-tile-2.jpg": 9227,
	"./images/news-tile-3.jpg": 4403,
	"./images/news-tile-4.jpg": 4677,
	"./images/partners-logo-1.png": 6591,
	"./images/partners-logo-2.png": 4228,
	"./images/partners-logo-3.png": 9097,
	"./images/partners-logo-4.png": 403,
	"./images/partners-logo-5.png": 3309,
	"./images/partners-logo-6.png": 5040,
	"./images/partners-logo-7.png": 3902,
	"./images/partners-logo-8.png": 4726,
	"./images/partners/1.png": 7677,
	"./images/partners/2.png": 7574,
	"./images/partners/3.png": 7278,
	"./images/partners/4.png": 7341,
	"./images/partners/5.png": 1888,
	"./images/partners/6.png": 9765,
	"./images/partners/7.png": 2811,
	"./images/partners/8.png": 2820,
	"./images/pdf-icon.svg": 5849,
	"./images/production-1.jpg": 2372,
	"./images/production-2.jpg": 6728,
	"./images/production-3.jpg": 1525,
	"./images/production-4.jpg": 5140,
	"./images/rad-2.svg": 5327,
	"./images/rad.svg": 5896,
	"./images/rectangle-white-2.png": 7369,
	"./images/rectangle-white.png": 4481,
	"./images/rectangle.png": 8819,
	"./images/rectangle.svg": 5637,
	"./images/right-arrow.svg": 7378,
	"./images/sber.svg": 9992,
	"./images/search.svg": 2058,
	"./images/shop/ecommerce-icons.svg": 9760,
	"./images/shop/mc.svg": 4751,
	"./images/shop/ms.svg": 4853,
	"./images/shop/pp.svg": 7381,
	"./images/shop/qiwi.svg": 3032,
	"./images/shop/visa-dark.svg": 1839,
	"./images/shop/visa.svg": 5204,
	"./images/shop/ym.svg": 7130,
	"./images/slider-1.png": 9564,
	"./images/slider-2.png": 9837,
	"./images/slider-3.png": 6812,
	"./images/slider-4.png": 5057,
	"./json/ajax.json": 7407
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3899;